module.exports = __webpack_public_path__ + "media/images/global-header-logo-usc-9e627f7556ab011b65ccbe131b4bbf25.png";